import * as e from "react";
import { forwardRef as o } from "react";
import { c as a } from "./index.js-Cr0Rsuyz.mjs";
function l(r, t) {
  return /* @__PURE__ */ e.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: t
  }, r), /* @__PURE__ */ e.createElement("path", {
    fill: "currentColor",
    d: "M17.97 4.97a.75.75 0 1 1 1.06 1.06L13.06 12l5.97 5.97a.75.75 0 1 1-1.06 1.06L12 13.06l-5.97 5.97a.75.75 0 1 1-1.06-1.06L10.94 12 4.97 6.03a.75.75 0 1 1 1.06-1.06L12 10.94z"
  }));
}
var i = a(/* @__PURE__ */ o(l));
export {
  i as I
};
